import { pxToRem } from '@withjoy/joykit/theme';
import type { BoxProps } from '@withjoy/joykit';
import type { DesignLayoutType } from '@graphql/generated-base';
import type { ScheduleLayoutType } from '@shared/components/ScheduleLayoutSelector/ScheduleLayoutSelector.types';
import type { Variant } from './ScheduleList.types';

// Kept out of ScheduleList.utils on purpose: this is imported by the eager Brannan
// layout chunk, and that module pulls deepmerge/date-fns-tz in for the lazy widget.

type BrannanCenteredScheduleProps = Readonly<{
  variant: Variant;
  margin?: string;
  maxWidth?: BoxProps['maxWidth'];
}>;

// Single source of truth for how the centered schedule layout is constrained on Brannan.
// Both the Brannan page renderer and the custom-JSON guest component read from here so they cannot drift.
export const getBrannanCenteredScheduleProps = (effectiveLayout: ScheduleLayoutType, layout: DesignLayoutType): BrannanCenteredScheduleProps => {
  const isCentered = effectiveLayout === 'centered';
  const isBrannan = layout === 'brannan';

  if (!isBrannan || !isCentered) {
    return { variant: isBrannan ? 'inline' : 'stack' };
  }

  return {
    variant: 'stack',
    margin: '0 auto',
    maxWidth: { _: 'auto', md: pxToRem(440), lg: pxToRem(480) },
  };
};
